import { render, staticRenderFns } from "./BlocoAlertaMonitoramentoSocioambiental.vue?vue&type=template&id=bac519f2&scoped=true&lang=pug"
import script from "./BlocoAlertaMonitoramentoSocioambiental.vue?vue&type=script&lang=js"
export * from "./BlocoAlertaMonitoramentoSocioambiental.vue?vue&type=script&lang=js"
import style0 from "./BlocoAlertaMonitoramentoSocioambiental.vue?vue&type=style&index=0&id=bac519f2&prod&lang=scss"
import style1 from "./BlocoAlertaMonitoramentoSocioambiental.vue?vue&type=style&index=1&id=bac519f2&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "bac519f2",
  null
  
)

export default component.exports